export const RETURN_URL_PARAM = 'returnUrl';
export const EMAIL_PARAM = 'email';
export const STATE_QUERY_PARAM = 'state';
export const DESTINATION_URL_PARAM = 'destinationUrl';
export const TOKEN_PARAM = 'token';
export const RETURN_URL_QUERY_PARAM = 'ReturnUrl';
export const NAVIGATE_BY_LINK_PARAM = 'navigateByLink';
export const CONNECTION_SETTINGS_CHANGED_PARAM = 'connectionSettingsChanged';
export const SESSION_EXPIRED_PARAM = 'session_expired';
export const LOGIN_PARAM = 'login';
export const ERROR_PARAM = 'errorCode';
